"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function EducaeetTestimonialsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultTestimonials = [
    { name: "Courtney Henry", role: "Undergraduate Student", text: "Instacks transformed my career. The courses are well-structured and the instructors are amazing!", image: "" },
    { name: "Albert Flores", role: "Software Engineer", text: "I learned more here in 3 months than in 2 years of college. Highly recommended!", image: "" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Student Testimonials"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="What Our Students Say"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Testimonials List</h4>
            <ListItemEditor
              label="Testimonials"
              items={content.testimonials || defaultTestimonials}
              itemSchema={[
                { key: "name", label: "Name", type: "text" },
                { key: "role", label: "Role / Designation", type: "text" },
                { key: "text", label: "Feedback Text", type: "text" },
                { key: "image", label: "User Photo", type: "image" },
              ]}
              onChange={(items) => handleChange({ ...content, testimonials: items })}
              addItemText="Add Testimonial"
            />
          </div>
        </div>
      }
    />
  );
}
